module.exports = __webpack_public_path__ + "static/media/triangle.6656562a.svg";